import enCommon from './locales/en/common.json';
import enFaceCapture from './locales/en/face-capture.json';
import idCommon from './locales/id/common.json';
import idFaceCapture from './locales/id/face-capture.json';

export const defaultLocale = 'en';

export const resources = {
  en: { 'common': enCommon, 'face-capture': enFaceCapture },
  id: { 'common': idCommon, 'face-capture': idFaceCapture },
} as const;
